// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_status_container__Qfr7K {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  
  .styles_aprovada__sCBid {
    background-color: green;
    border-radius: 50%;
    height: 0.7rem;
    margin-right: 0.3rem;
    width: 0.7rem;
  }
  
  .styles_andamento__8GcqH {
    background-color: orange;
    border-radius: 50%;
    height: 0.7rem;
    margin-right: 0.3rem;
    width: 0.7rem;
  }
  
  .styles_pendente__SxtAn {
    background-color: red;
    border-radius: 50%;
    height: 0.7rem;
    margin-right: 0.3rem;
    width: 0.7rem;
  }
  
  .styles_cancelada__N-fTP {
    background-color: rgb(177, 0, 0);
    border-radius: 50%;
    height: 0.7rem;
    margin-right: 0.3rem;
    width: 0.7rem;
  }
  
  .styles_documentacao__Y5uHo {
    background-color: rgb(255, 102, 0);
    border-radius: 50%;
    height: 0.7rem;
    margin-right: 0.3rem;
    width: 0.7rem;
  }
  
  .styles_enviada__me2Nq {
    background-color: rgb(28, 42, 235);
    border-radius: 50%;
    height: 0.7rem;
    margin-right: 0.3rem;
    width: 0.7rem;
  }

  /* Listras zebradas APENAS para a tabela de prévias INSS */
  .styles_tablePreviaInss__GdFDT tbody tr:nth-child(even) {
    background-color: #f9fbff;
  }

  .styles_tablePreviaInss__GdFDT tbody tr:nth-child(odd) {
    background-color: #ffffff;
  }

  .styles_tablePreviaInss__GdFDT tbody tr:hover {
    background-color: #f0f4ff !important;
  }
`, "",{"version":3,"sources":["webpack://./src/pages/PreviaINSS/styles.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,kCAAkC;IAClC,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,kCAAkC;IAClC,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,aAAa;EACf;;EAEA,0DAA0D;EAC1D;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;EACtC","sourcesContent":[".status_container {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .aprovada {\n    background-color: green;\n    border-radius: 50%;\n    height: 0.7rem;\n    margin-right: 0.3rem;\n    width: 0.7rem;\n  }\n  \n  .andamento {\n    background-color: orange;\n    border-radius: 50%;\n    height: 0.7rem;\n    margin-right: 0.3rem;\n    width: 0.7rem;\n  }\n  \n  .pendente {\n    background-color: red;\n    border-radius: 50%;\n    height: 0.7rem;\n    margin-right: 0.3rem;\n    width: 0.7rem;\n  }\n  \n  .cancelada {\n    background-color: rgb(177, 0, 0);\n    border-radius: 50%;\n    height: 0.7rem;\n    margin-right: 0.3rem;\n    width: 0.7rem;\n  }\n  \n  .documentacao {\n    background-color: rgb(255, 102, 0);\n    border-radius: 50%;\n    height: 0.7rem;\n    margin-right: 0.3rem;\n    width: 0.7rem;\n  }\n  \n  .enviada {\n    background-color: rgb(28, 42, 235);\n    border-radius: 50%;\n    height: 0.7rem;\n    margin-right: 0.3rem;\n    width: 0.7rem;\n  }\n\n  /* Listras zebradas APENAS para a tabela de prévias INSS */\n  .tablePreviaInss tbody tr:nth-child(even) {\n    background-color: #f9fbff;\n  }\n\n  .tablePreviaInss tbody tr:nth-child(odd) {\n    background-color: #ffffff;\n  }\n\n  .tablePreviaInss tbody tr:hover {\n    background-color: #f0f4ff !important;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status_container": `styles_status_container__Qfr7K`,
	"aprovada": `styles_aprovada__sCBid`,
	"andamento": `styles_andamento__8GcqH`,
	"pendente": `styles_pendente__SxtAn`,
	"cancelada": `styles_cancelada__N-fTP`,
	"documentacao": `styles_documentacao__Y5uHo`,
	"enviada": `styles_enviada__me2Nq`,
	"tablePreviaInss": `styles_tablePreviaInss__GdFDT`
};
export default ___CSS_LOADER_EXPORT___;
